/**
 * Numer telefonu → E.164, albo `null`, gdy z zapisu nie da się go odczytać.
 *
 * Numery leżą we wspólnej kartotece (`users.phone`, `shop_floor_workers.phone`)
 * w kształtach wpisanych ręcznie — zmierzone 03.11.2026 na produkcji:
 * `+48 999 999 999`, `+48999 999 999`, `+48999999999` i gołe `999999999`.
 * Twilio przyjmuje wyłącznie E.164, więc normalizujemy tutaj, a NIE w bazie:
 * poprawianie cudzej kartoteki przy wysyłce alarmu to druga prawda o numerze.
 *
 * Reguła: odstępy, myślniki, kropki i nawiasy znikają; `00` z przodu to `+`;
 * dziewięć cyfr bez kierunkowego to numer polski (`+48`), bo platforma działa
 * w Polsce i tak zapisuje go hala. Wynik musi mieć postać `+[1-9]\d{7,14}` —
 * wszystko inne to „numer niepoprawny” (stan nazwany przez nadawcę, nie cisza).
 */
export function naE164(surowy: string | null | undefined): string | null {
  if (typeof surowy !== 'string') return null;
  let n = surowy.trim().replace(/[\s\-.()]/g, '');
  if (n === '') return null;
  if (n.startsWith('00')) n = `+${n.slice(2)}`;
  if (/^\d{9}$/.test(n)) n = `+48${n}`;
  return /^\+[1-9]\d{7,14}$/.test(n) ? n : null;
}

/** Ostatnie trzy cyfry — jedyne, co z numeru trafia do dziennika i logu. */
export function koncowkaNumeru(e164: string): string {
  return e164.replace(/\D/g, '').slice(-3);
}
